import React, { PropTypes, Component } from 'react';
import { Styles, Paper, IconButton } from 'material-ui';
import * as Icons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';

const { Spacing } = Styles;

const phoneWidth = 5;
const width = 8;

const styles = {
  root: {
    padding: 0,
    height: 36,
    whiteSpace: 'nowrap',
    position: 'relative',
    backgroundColor: 'transparent'
  },
  inputContainer: {
    backgroundColor: Colors.Colors.fullWhite,
    position: 'absolute',
    right: 36,
    left: 0,
    top: 0,
    bottom: 0
  },
  input: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    width: '100%',
    padding: `0 ${Spacing.desktopGutterMini}px`,
    verticalAlign: 'top',
    lineHeight: `${36}px`,
    height: 36,
    textAlign: 'left',
    boxSizing: 'border-box'
  },
  button: {
    verticalAlign: 'top',
    display: 'inline-block',
    margin: 0,
    border: 'none',
    width: 36,
    height: 36,
    position: 'absolute',
    right: 0,
    top: 0,
    padding: (36 - Spacing.iconSize) / 2,
    lineHeight: `${36}px`,
    backgroundColor: 'rgba(0, 0, 0, 0.2)'
  }
};

export default class SearchBar extends Component {
  static displayName = 'SearchBar';

  static contextTypes = {
    media: PropTypes.string
  };

  static defaultProps = {
    placeholder: 'Search',
    fullWidth: false
  };

  constructor(props) {
    super(props);

    this.state = {
      searchText: null,
      typingTimeout: 0,
    };

    this.baseState = this.state;
  }

  componentWillUnmount() {
    this.setState(this.baseState);
  }

  getStyle() {
    let style = Object.assign({}, styles.root);
    if (this.props.fullWidth) {
      style.display = 'block';
    } else {
      style.display = 'inline-block';
      if (this.context.media === 'phone') {
        style.width = Spacing.desktopKeylineIncrement * phoneWidth;
      } else {
        style.width = Spacing.desktopKeylineIncrement * width;
      }
    }
    return style;
  }

  getInputStyle() {
    let style = Object.assign({}, styles.input);
    return style;
  }

  searchTextChange = event => {
    const newValue = event.target.value || '';
    this.setState({searchText: newValue});

    if (!this.props.onChange) {
      return;
    }

    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }
    this.setState({
      searchText: newValue,
      typingTimeout: setTimeout(() => { this.props.onChange(newValue) }, 500),
    });
  };

  searchHandler = event => {
    if (!this.props.onSearch) {
      return;
    }
    this.props.onSearch(this.state.searchText);
  };

  render() {
    return (
      <Paper style={this.getStyle()}>
        <div style={styles.inputContainer}>
          <input
            style={this.getInputStyle()}
            type="text"
            placeholder={this.props.placeholder}
            onChange={this.searchTextChange}
          />
        </div>
        <IconButton style={styles.button} onTouchTap={this.searchHandler}>
          <Icons.ActionSearch
            color={Colors.Colors.fullWhite}
            hoverColor={Colors.Colors.lightWhite}
          />
        </IconButton>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/SearchBar.js